/**
 * Where online play connects (docs/architecture.md §7–8). Tiny and dependency-free, so the menus
 * can ask "online or offline?" without loading the online code (net/online.ts, lazy).
 */
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string | undefined;
export const SUPABASE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined;
const params = typeof location !== 'undefined' ? new URLSearchParams(location.search) : new URLSearchParams();
/**
 * Game server; in dev the local one (npm run dev -w @caged/server). Dev builds also take
 * ?server=ws://… (tests run their own server).
 */
export const SERVER =
  (import.meta.env.DEV && params.get('server')) ||
  (import.meta.env.VITE_GAME_SERVER as string | undefined) ||
  (import.meta.env.DEV && typeof location !== 'undefined' ? `ws://${location.hostname}:2567` : '');
/** Dev builds: ?devguest plays without a Supabase account (the server must allow dev guests). */
export const DEV_GUEST = import.meta.env.DEV && params.has('devguest');

/** The game server's HTTP address (its progression API) from the WebSocket one. */
export const SERVER_HTTP = SERVER.replace(/^ws/, 'http');

/**
 * Whether progression lives on the game server (Milestone 4, D25–D26): any build with a game
 * server. Dev builds can keep Milestone 1's local progression with ?local (the full-loop test
 * against the local bot).
 */
export function serverProgress(): boolean {
  return !!SERVER && !(import.meta.env.DEV && params.has('local'));
}

/** A dev guest's own id, kept in this browser so its progress lasts between fights (dev builds). */
export function devGuestId(): string {
  try {
    let id = localStorage.getItem('caged.devGuest.v1');
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem('caged.devGuest.v1', id);
    }
    return id;
  } catch {
    return 'no-storage-dev-guest';
  }
}

/** Whether this build can play online at all (a server is configured). */
export function onlineConfigured(): boolean {
  // ?offline forces a local bot; so does the ?fight dev shortcut (straight into a fight).
  return !!SERVER && !params.has('offline') && !params.has('fight');
}

